import { DateTime } from 'luxon'
import { effectiveTimezone } from '../store/authState.ts'
import { dataState } from '../store/dataState.ts'
import { IDevice, IDeviceStatus, IPet } from '../interfaces/types'
import { isLocationValid } from './locationStatusHelper.ts'

export const getMostRecent = (d: IDevice) => {
    const mostRecentLocation = d?.lastLocation
    const mostRecentEvent = d?.lastEvent

    const source = isLocationValid(mostRecentLocation?.properties) ? mostRecentLocation?.properties?.gibiMessageType :
        d.lastLocation?.properties?.gibiMessageType
    const valid = isLocationValid(mostRecentLocation?.properties) ? mostRecentLocation : d.lastLocation


    const tz = effectiveTimezone().value
    const locationDate = valid ? DateTime.fromSeconds(valid.properties?.timeStamp).setZone(tz) : null
    const eventDate: DateTime | null = mostRecentEvent ? DateTime.fromISO(mostRecentEvent.createdAt).setZone(tz) : null

    // get last contact date
    let lastContactDate: DateTime | string | null = locationDate === null && eventDate === null ? null :
        locationDate === null ? eventDate :
            eventDate === null ? locationDate :
                locationDate < eventDate ? eventDate : locationDate

    lastContactDate = lastContactDate ? lastContactDate.toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY) : 'unknown'

    let batteryDate = ''
    let batteryPercent = ''
    let deviceStatus: IDeviceStatus = {} as IDeviceStatus
    if (mostRecentEvent) {
        if (mostRecentLocation) {
            batteryDate = locationDate?.toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY) || ''
            batteryPercent = mostRecentLocation?.properties?.batteryPercent || '--'
            deviceStatus = mostRecentEvent?.deviceUpdate?.deviceStatus || {} as IDeviceStatus
        } else {
            batteryDate = eventDate!.toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY)!
            batteryPercent = mostRecentEvent?.deviceUpdate?.deviceStatus?.batteryPercent || '--'
            deviceStatus = mostRecentEvent?.deviceUpdate?.deviceStatus || {} as IDeviceStatus
        }
    } else if (mostRecentLocation) {
        batteryDate = locationDate?.toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY) || ''
        batteryPercent = mostRecentLocation?.properties?.batteryPercent || '--'
        deviceStatus = d?.status || {} as IDeviceStatus
    }

    return {
        lastContactDate,
        batteryDate,
        batteryPercent,
        deviceStatus,
        locationDate: locationDate?.toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY),
        locationDateMs: locationDate?.toMillis(),
        lastLocation: valid,
        positionSource: source,
    }
}

export const petFromDevice = (device: IDevice): IPet | undefined => {
    return dataState.pets.find(p => p._id == device.petId)
}

export const deviceFromPet = (pet: IPet): IDevice | undefined => {
    return dataState.devices.find(d => d.petId == pet._id)
}

export const calculateAge = (date: string) => {
    const dob = new Date(date)
    const month_diff = Date.now() - dob.getTime()
    const age_dt = new Date(month_diff)
    const year = age_dt.getUTCFullYear()
    return Math.abs(year - 1970)
    // const bd = DateTime.fromISO(date)
    // const currentDate = DateTime.now();
    // const difference = currentDate.toMillis() - bd.toMillis();
    // const currentAge = Math.floor(difference / 31557600000)
    // // dividing by 1000*60*60*24*365.25
    // return currentAge
}

export const getAge = (fromdate: string, desktop?: boolean) => {
    const todate = new Date()

    const fromDate = new Date(fromdate)
    const age = [],
        y = [todate.getFullYear(), fromDate.getFullYear()],
        m = [todate.getMonth(), fromDate.getMonth()],
        d = [todate.getDate(), fromDate.getDate()]

    let mdiff = m[0] - m[1],
        ydiff = y[0] - y[1]
    const ddiff = d[0] - d[1]

    if (mdiff < 0 || (mdiff === 0 && ddiff < 0)) --ydiff
    if (mdiff < 0) mdiff += 12
    if (ddiff < 0) {
        fromDate.setMonth(m[1] + 1, 0)
        // ddiff = fromDate.getDate() - d[1] + d[0]
        --mdiff
    }
    const months = desktop ? ` month${mdiff > 1 ? 's' : ''}` : 'm'
    if (ydiff > 0) age.push(ydiff + ' year' + (ydiff > 1 ? 's ' : ''))
    if (mdiff > 0) age.push(mdiff + months)
    if (!age.length) {
        const days = Math.abs(ddiff)
        age.push(days+ ' day'+(days> 1? 's':''));
    }
    if (age.length > 1) age.splice(age.length - 1, 0, ' ')
    return age.join('')
}

export const getPetLastLocation = (pet: IPet) => {
    const device = deviceFromPet(pet)
    return device?.lastLocation
}

export const isPetOn = (pet: IPet) => {
    const device = deviceFromPet(pet)
    return device?.status?.powerOn
}

export const getPetsWIthDevices = () => {
    const devices = dataState.devices
    const pets = dataState.pets
    return pets.map(p => devices.find(d => p._id === d.petId)).filter(n => n).map(d => d!.petId)
}

export const renewsOn = (timeZone: { value: any }, startDate: string | undefined, planType: string | undefined) => {
    let renews = ''
    if (!startDate || !planType) return renews
    if (planType.toLowerCase().includes('month')) {
        const monthsSinceStart = DateTime.fromISO(startDate).diffNow('months').months
        let increment
        if (monthsSinceStart < 1) {
            increment = Math.ceil(Math.abs(monthsSinceStart))
        } else {
            increment = Math.ceil(monthsSinceStart)
        }
        renews = DateTime.fromISO(startDate)
            .setZone(timeZone.value)
            .plus({ month: increment })
            .toLocaleString(DateTime.DATE_MED)
    } else {
        const yearsSinceStart = DateTime.fromISO(startDate).diffNow('years').years
        let increment
        if (yearsSinceStart < 1) {
            increment = Math.ceil(Math.abs(yearsSinceStart))
        } else {
            increment = Math.ceil(yearsSinceStart)
        }
        renews = DateTime.fromISO(startDate)
            .setZone(timeZone.value)
            .plus({ year: increment })
            .toLocaleString(DateTime.DATE_MED)
    }
    return renews
}

export const shapeAddress = (formData: any) => ({
    firstName: formData.firstName,
    lastName: formData.lastName,
    mobile: formData.mobile,
    address1: formData.addr1,
    address2: formData.addr2,
    city: formData.city,
    state: formData.state,
    postalCode: formData.postalCode,
    country: formData.country,
    timeZone: formData.timeZone,
    smsOptIn: formData.smsOptIn,
})

export const readableSeconds = (sec: number) => {
    const label = sec < 60 ? 'seconds' : sec === 60 ? 'minute' : sec/60 < 60 ? 'minutes' : 'hour'
    const val = sec < 60 ? sec : sec / 60 < 60 ? sec / 60 : 1
    return `${val} ${label}`
}
